import { css } from 'styled-components';
import { COLORS } from '../../../config/theme';

const style = () => css`
    .header {
        display: flex;
        align-items: center;
        margin-bottom: 10px;

        .flex-1 {
            flex: 1;
        }

        .subscriber-count {
            color: ${(props) => props.theme[COLORS.PRIMARY_TEXT]};
            font-weight: 500;
        }
    }

    .ant-table {
        box-shadow: ${(props) => props.theme[COLORS.CARD_SHADOW]};
        border-radius: 15px;
        overflow: hidden;

        .ant-table-thead > tr > th {
            font-weight: 600;
        }
    }
`;

export default style();
